"use client";

import dynamic from "next/dynamic";
import type { TradesPerson } from "./TradespersonCard";

const BrowseMap = dynamic(() => import("./BrowseMap"), {
  ssr: false,
  loading: () => (
    <div className="w-full h-[350px] sm:h-[420px] rounded-lg bg-cream animate-pulse border border-stone/30" />
  ),
});

interface BrowseMapWrapperProps {
  tradespeople: TradesPerson[];
  center: { lat: number; lng: number } | null;
  radiusMiles: number;
}

export function BrowseMapWrapper({ tradespeople, center, radiusMiles }: BrowseMapWrapperProps) {
  return <BrowseMap tradespeople={tradespeople} center={center} radiusMiles={radiusMiles} />;
}
